import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { settings } from 'environments/environment';

/**
 * Guard sprawdzający czy REST API jest włączone w ustawieniach środowiska.
 * Jeśli REST API jest wyłączone, route nie zostanie dopasowany (canMatch zwraca false).
 */
export const RestApiEnabledGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);

  if (!settings.enableRestAPI) {
    // Przekieruj na dokumenty jeśli REST API jest wyłączone
    router.navigate(['/konto/dokumenty']);
    return false;
  }

  return true;
};
